export default function PHP_zip_entry_close() {
  return (
    <div>
      <h1>PHP_zip_entry_close</h1>
    </div>
  );
}
